import OpeningTimesForm from "../components/features/OpeningTimesForm";
import WebsitePopupForm from "../components/features/WebsitePopupForm";

function Teacher() {
    return (
        <main id="teacher-main">
            <h1>Lærer admin</h1>
            <div id="teacher-tools-container">
                <div id="website-opening-times-teacher-page">
                    <h2>Nettside åpningstider</h2>
                    <OpeningTimesForm />
                </div>
                <div id="website-pop-up-teacher-page">
                    <h2>Nettside beskjed</h2>
                    <WebsitePopupForm />
                </div>
            </div>
        </main>
    );
};

export default Teacher;